import { MessageCircle } from "lucide-react";
import { useSiteSettings } from "@/hooks/useSiteSettings";

const WhatsAppWidget = () => {
  const { getSetting } = useSiteSettings();
  const enabled = getSetting("whatsapp_enabled", "false") === "true";
  const number = getSetting("whatsapp_number", "");
  const message = getSetting("whatsapp_message", "");

  if (!enabled || !number) return null;

  const url = `https://wa.me/${number}${message ? `?text=${encodeURIComponent(message)}` : ""}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 rounded-none bg-[hsl(142,70%,40%)] text-white shadow-lg hover:scale-110 hover:shadow-xl transition-all duration-300 border-2 border-[hsl(142,70%,35%)]"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle className="w-7 h-7" />
    </a>
  );
};

export default WhatsAppWidget;
